$( document ).ready(function() {


///rc.setAttribute('href', '/cart/' + vid + ':1');



  
$(".hide-sticky-product").click(function(){ 
  setTimeout(function () { 
  $(".ajax-cart__button").trigger('click');
   }, 2500); 
});
  
$(".gb-sticky-add-button").click(function(){ 
  setTimeout(function () { 
  $(".ajax-cart__button").trigger('click');
   }, 2500); 
});


 $(".gb-default-click2-Pack").trigger('click');
var get_variant =  $(".gb-sticky-select-id-variant").text();
    setTimeout(function () { 
       $(".gb-variant-selection").attr('variant' , get_variant);
    }, 2500);    

  $(".vb-sticky-pack-menu li").click(function(){    
		var get_variant = $(this).attr('data-variant-id');
    $('.gb-variant-selection').attr('variant' , get_variant);
    var get_save = $(this).attr('get-save-price');
    $('.gb-sticky-add-button').html(get_save);

    $('.gb-sticky-add-button').attr('href' , '/cart/' + get_variant + ':1');   

  });
 
 $(".gb-swatch__options").click(function(){    
		var get_variant2 = $(this).attr('variant-id');
   // $('.gb-variant-selection').attr('variant' , get_variant2);
    $('.hide-sticky-product').attr('href' , '/cart/' + get_variant2 + ':1');   

  });

var gb_default_price = $(".swatch input:checked+.swatch-element").find(".main-package .get-price-each").html();
 $('.hide-sticky-product').html(gb_default_price);
  $(".main-package").click(function(){    
		var get_save = $(this).find('.get-price-each').html();
    $('.hide-sticky-product').html(get_save);
  });


  $(".gb-sticky-dropdown").change(function(){    
		var get_save = $('option:selected', this).attr('get-save-price');
    $('.gb-sticky-add-button').html(get_save);
  });

    $(".vb-image-with-text-icon p").append('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.96364 0.792175H10.2385C10.4661 0.820954 10.6941 0.845884 10.9209 0.878879C12.8147 1.1553 14.4931 1.91016 15.9259 3.179C17.6659 4.71877 18.7263 6.6411 19.0887 8.94122C19.1312 9.21086 19.1631 9.48233 19.2 9.75308V11.0278C19.171 11.2558 19.1472 11.4844 19.1127 11.7115C18.729 14.2424 17.5524 16.3281 15.5445 17.9149C13.4166 19.5968 10.9796 20.2583 8.29558 19.8961C5.75863 19.5535 3.67561 18.351 2.08448 16.3457C0.394703 14.2149 -0.258142 11.774 0.0911059 9.08218C0.337504 7.18313 1.11465 5.5057 2.38404 4.07023C3.92495 2.32791 5.84902 1.26566 8.15112 0.903443C8.42153 0.860916 8.69305 0.82902 8.96364 0.792175ZM8.14397 11.9922L8.09318 11.9577C8.08226 11.9518 8.07184 11.9451 8.06202 11.9375C7.601 11.5159 7.14004 11.0943 6.67914 10.6727C6.27288 10.3024 5.87872 9.91713 5.45375 9.5694C4.93566 9.14523 4.15081 9.41579 3.99205 10.0603C3.8936 10.4592 4.01991 10.7935 4.32479 11.0707C5.36123 12.0116 6.39577 12.9541 7.42842 13.8982C7.92653 14.3526 8.43161 14.3438 8.91341 13.8659C10.9007 11.8944 12.8875 9.92251 14.8737 7.95027C14.9365 7.88943 14.9951 7.82445 15.0492 7.75578C15.4494 7.23262 15.2079 6.46017 14.5787 6.2633C14.1571 6.13132 13.8152 6.2721 13.5125 6.57602C11.7697 8.32354 10.0251 10.0693 8.27872 11.8133C8.22628 11.8659 8.18852 11.9326 8.14397 11.9927V11.9922Z" fill="black"/></svg>');
   //$(".accordion__button").click(function(){ 
   
  
  $('.vb-logo-list').slick({
  autoplay: true,
  infinite: true,
  autoplaySpeed: 0,
  slidesToScroll: 1,
  slidesToShow: 6,
  arrows: false,
  centerMode: true,   
  cssEase: 'linear',
  speed: 10000,
  //initialSlide: 1,
  draggable: false,
  //pauseOnHover: true,
    		 responsive: [
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
  ]
  });

if (window.matchMedia("(max-width: 1023px)").matches) {
$('.text-with-icon-slider-m').slick({
        infinite: true,
        speed: 300,
        autoplay: true,
        slidesToShow: 8,
        slidesToScroll: 1,
        centerMode: true,
        arrows: false,
        prevArrow: $('.prev-graam'),
        nextArrow: $('.next-graam'),
		 responsive: [
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
  ]
});
}
   if (window.matchMedia("(min-width: 1024px)").matches) {

  //document.querySelector('.vb-button-text-btn a').addEventListener('click', function (){
  $(".vb-button-text-btn a").click(function(){    
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RcMZ88']);
	});
  //document.querySelector('a.text-with-image-main-one-btn').addEventListener('click', function (){
  $("a.text-with-image-main-one-btn").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RcMZ88']);
	});
  $("a.vb-video-btn-tx").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RcMZ88']);
	});
  
  $(".vb-block__featured-promo a.button").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RcMZ88']);
	});
   }
  
  if (window.matchMedia("(max-width: 1023px)").matches) {

  //document.querySelector('.vb-button-text-btn a').addEventListener('click', function (){
  $(".vb-button-text-btn a").click(function(){    
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Yt2htt']);
	});
  //document.querySelector('a.text-with-image-main-one-btn').addEventListener('click', function (){
  $("a.text-with-image-main-one-btn").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Yt2htt']);
	});
  $("a.vb-video-btn-tx").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Yt2htt']);
	});
  
  $(".vb-block__featured-promo a.button").click(function(){  
		window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Yt2htt']);
	});

  }

  $(document).ready(function(){ 
        setTimeout(function(){
        //  $(".vb-image-hide").show(); // Hide the message after 3 seconds
        $('.product-gallery').css({"opacity": "1"});
      }, 2000); // 3000 milliseconds = 3 seconds
  }); 



});

window.setTimeout(function(){
   if (window.matchMedia('(max-width: 767px)').matches) {
    if(window.location.hash){
        var $target  = $(window.location.hash).closest("#vb-video-main");
        if($target.length)
            $('html, body').animate({scrollTop: $target.offset().top  - 300 }, 1000);
    }
  }
}, 1000);



/*document.addEventListener('DOMContentLoaded', function() {
    const stickyBar = document.getElementById('stickyBar');
    const targets = [
        document.querySelector('.hero-split-btn'),
        document.querySelector('.closing-cta-section')
    ].filter(Boolean);
    function updateVisibility() {
        let visible = false;
        targets.forEach(el => {
            const rect = el.getBoundingClientRect();

            if (
                rect.top < window.innerHeight &&
                rect.bottom > 0
            ) {
                visible = true;
            }
        });
        stickyBar.classList.toggle('show', !visible);
    }
    window.addEventListener('scroll', updateVisibility);
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
});*/


/*document.addEventListener('DOMContentLoaded', function() {
    const stickyBar = document.getElementById('stickyBar-product');
    const targets = [
        document.querySelector('.hide-sticky-product'),
        document.querySelector('.closing-cta-section')
    ].filter(Boolean);
    function updateVisibility() {
        let visible = false;
        targets.forEach(el => {
            const rect = el.getBoundingClientRect();

            if (
                rect.top < window.innerHeight &&
                rect.bottom > 0
            ) {
                visible = true;
            }
        });
        stickyBar.classList.toggle('show', !visible);
    }
    window.addEventListener('scroll', updateVisibility);
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
});*/

document.querySelectorAll('.feature-video').forEach(video => {
    video.load();
});

/* VB! add this code for "cart page varient" STARTS*/
(function () {
  // Loading styles
  var styleTag = document.createElement("style");
  styleTag.textContent =
    ".variant-btn:disabled{opacity:.55;cursor:wait}" +
    ".variant-btn.loading{position:relative;color:transparent}" +
    ".variant-btn.loading small{visibility:hidden}" +
    ".variant-btn.loading::after{" +
    "content:'';" +
    "position:absolute;" +
    "top:50%;" +
    "left:50%;" +
    "width:14px;" +
    "height:14px;" +
    "margin:-7px 0 0 -7px;" +
    "border:2px solid #567040;" +
    "border-top-color:transparent;" +
    "border-radius:50%;" +
    "animation:vbspin .6s linear infinite;" +
    "}" +
    "@keyframes vbspin{to{transform:rotate(360deg)}}";
  document.head.appendChild(styleTag);
  let switching = false;
  document.addEventListener("click", async function (e) {
    const btn = e.target.closest(".variant-btn");
    if (!btn) return;
    e.preventDefault();
    if (switching) return;
    if (btn.disabled) return;
    if (btn.classList.contains("active")) return;
    const card = btn.closest(".cart__card");
    if (!card) return;
    const activeBtn = card.querySelector(".variant-btn.active");
    const oldVariantId = activeBtn ? activeBtn.dataset.variantId : null;
    const newVariantId = btn.dataset.variantId;
    if (!oldVariantId || !newVariantId) return;
    switching = true;
    document.querySelectorAll(".variant-btn").forEach(function (b) {
      b.disabled = true;
    });
    // ===== Instant UI =====
    if (activeBtn) {
      activeBtn.classList.remove("active");
    }
    btn.classList.add("active");
    btn.classList.add("loading");
    // Let browser paint before fetch
    await new Promise(requestAnimationFrame);
    const qtyInput = card.querySelector("input[name='updates[]'], input[name='quantity']");
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    // Merge if same variant already exists
    let targetQty = qty;
    document.querySelectorAll(".cart__card").forEach(function (otherCard) {
      if (otherCard === card) return;
      const otherActive = otherCard.querySelector(".variant-btn.active");
      if (
        otherActive &&
        otherActive.dataset.variantId === newVariantId
      ) {
        const otherQtyInput = otherCard.querySelector("input[name='updates[]'], input[name='quantity']");
        targetQty += otherQtyInput
          ? parseInt(otherQtyInput.value, 10) || 0
          : 0;
      }
    });
    try {
      const updates = {};
      updates[oldVariantId] = 0;
      updates[newVariantId] = targetQty;
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          updates: updates
        })
      });
      if (!response.ok) {
        throw new Error("Cart update failed");
      }
      const cart = await response.json();
      if (
        window.PXUTheme &&
        window.PXUTheme.jsCart &&
        typeof window.PXUTheme.jsCart.updateView === "function"
      ) {
        window.PXUTheme.jsCart.updateView(cart, null);
      } else {
        location.reload();
      }
    } catch (err) {
      console.error(err);
      location.reload();
    } finally {
      setTimeout(function () {
        switching = false;
        document.querySelectorAll(".variant-btn").forEach(function (b) {
          b.disabled = false;
          b.classList.remove("loading");
        });
      }, 10);
    }
  });
})();
/* VB! add this code for "cart page varient" ENDS*/